import { render, staticRenderFns } from "./operateRecords.vue?vue&type=template&id=abfecd38&scoped=true&"
import script from "./operateRecords.vue?vue&type=script&lang=js&"
export * from "./operateRecords.vue?vue&type=script&lang=js&"
import style0 from "./operateRecords.vue?vue&type=style&index=0&id=abfecd38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfecd38",
  null
  
)

export default component.exports